import GlaromatUserModelBase from '../_generated/modelBases/glaromat-user-model-base';

export default class GlaromatUserModel extends GlaromatUserModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
